module.exports = __webpack_public_path__ + "static/logo-e8a324fd7899a6aa1c8a4517318d1982.png";